<template>
  <div class="data modal-container">
    <div class="modal-header">
      <div class="corner-container left">
        <div>
          <div class="header-label organization"> <b> {{ headerText }} </b> </div>
        </div>
        <div>
          <div class="helper-text"> <b>Key Type:</b> </div>
          <p class="helper-text-data">{{ keyType }}</p>
        </div>
        <div>
          <div class="helper-text"> <b>Visitor Type</b> </div>
          <p class="helper-text-data">{{ visitorType }}</p>
        </div>
      </div>
      <div class="circle-container">
        <div class="circle">
          <button style="width: 100%; height: 100%;" @click="changeAssignee()">
            {{ circleText }}
          </button>
        </div>
      </div>
      <div class="corner-container right">
        <button class="header-label" @click="close">X</button>
        <div>
          <div class="helper-text"><b>Key Status</b></div>
          <p class="helper-text-data">{{ keyStatus }}</p>
        </div>
        <div>
          <div class="helper-text"><b>Key ID</b></div>
          <p class="helper-text-data">{{ keyId }}</p>
        </div>
      </div>
    </div>
    <div class="modal-fields">
      <div class="modal-field">
        <div class="helper-text">Visitor Name</div>
        <p class="center-text">{{ visitorName }}</p>
      </div>
      <div class="modal-field">
        <div class="helper-text">Resident Name</div>
        <p class="center-text"> {{ residentName }}</p>
      </div>
      <div class="modal-field">
        <div class="helper-text">Visiting Address</div>
        <p class="center-text">{{ visitingAddress }}</p>
      </div>
      <div class="modal-field">
        <div class="helper-text">Visitor License Plate</div>
        <p class="center-text">{{ visitorLicensePlate }}</p>
      </div>
      <div class="modal-field">
        <div class="helper-text">Key Delivery Methods</div>
        <p class="center-text">{{ deliveryMethods }}</p>
      </div>
      <div class="modal-field">
        <div class="helper-text">Visitor Phone Number</div>
        <p class="center-text">{{ visitorPhoneNumber }}</p>
      </div>
      <div class="modal-field">
        <div class="helper-text">Visitor Email</div>
        <p class="center-text">{{ visitorEmail }}</p>
      </div>
      <!-- <div class="modal-field">
          <div class="helper-text">Visiting Reason</div>
          <p class="center-text">{{ visitingReason }}</p>
        </div> -->
    </div>

    <div class="additional-data">
      <div class="additional-data-item">
        <b>
          <p>Start Time</p>
        </b>
        <p>{{ timeActive }}</p>
      </div>
      <div style="display:block; width: 1px; height: 100%; background-color: white;"></div>
      <div class="additional-data-item">
        <b>
          <p>Expiration Time</p>
        </b>
        <p>{{ timeExpiration }}</p>
      </div>
      <div style="display:block; width: 1px; height: 100%; background-color: white;"></div>
      <div class="additional-data-item">
        <b>
          <p>Last Scanned</p>
        </b>
        <p>{{ lastScanned }}</p>
      </div>
      <div style="display:block; width: 1px; height: 100%; background-color: white;"></div>
      <div class="additional-data-item">
        <b>
          <p>Rules Accepted</p>
        </b>
        <br>
        <p>{{ rulesAccepted }}</p>
      </div>
    </div>
    <div class="button-container">
      <div class="modal-triple-button-row">
        <button class="resend button" @click="resendKey()">Resend Key</button>
        <button class="update button" @click="updateKey()">Update Key</button>
        <button class="cancel button" @click="cancelKey()">Cancel Key</button>
      </div>
      <button v-if="validateKeyEnabled" class="validate button" @click="validateKey()"> Validate Key </button>
    </div>
  </div>
</template>

<script>
import * as Constants from '../../js/constants'
import CTSRepository from '../../js/CTSRepository';
import ConfirmationModal from './ConfirmationModal.vue';
import EditKeyModal from './edit/EditKeyModal.vue';
const NAME = Constants.GATE_MODAL

export default {
  modalName: NAME,
  components: {
  },
  props: ["keyData", "organizationData", "userData"],
  watch: {
    keyData: function (newVal) {
      console.log("Params keyData Changed", newVal)
      this.payload = newVal;
      console.log("Params New Payload", this.payload)

    },
  },
  opened(event) {
    console.log('Opening...', event)
  },
  data() {
    return {
      modalName: NAME,
      payload: this.$props.keyData,
      date: new Date(),
      showDialog: true,
    }
  },
  computed: {
    headerText: function () {
      return `${this.getMappedName(this.$props.organizationData.organization_id)} ${this.payload.subdivision ? `- ${this.payload.subdivision}` : ''}`
    },
    circleText: function () {
      return `${this.payload.visitor_first_name[0]}${this.payload.visitor_last_name[0]}`
    },
    keyType: function () {
      return this.payload.key_type
    },
    visitorType: function () {
      return this.payload.visitor_relationship
    },
    keyStatus: function () {
      return this.payload.current_status
    },
    keyId: function () {
      return this.payload.key_id
    },
    visitorName: function () {
      return `${this.payload.visitor_first_name} ${this.payload.visitor_last_name}`
    },
    residentName: function () {
      return `${this.payload.user_first_name} ${this.payload.user_last_name}`

    },
    visitingAddress: function () {
      return `${this.payload.unit_data.unit_full_address}`

    },
    visitorLicensePlate: function () {
      return `${this.payload.visitor_license_plate}`
    },
    visitorVehicleType: function () {
      return ``

    },
    visitorPhoneNumber: function () {
      if(this.payload.visitor_phone_number == "+1") {
        return "N/A"
      }
      return `${this.payload.visitor_phone_number}`.replace(/^(.{2})(\d{3})(\d{3})(\d{4})/, '$1 $2-$3-$4').replace(/(\d{3})(\d{3})(\d{4})/, '$1-$2-$3')
    },
    visitorEmail: function () {
      return `${this.payload.visitor_email}`
    },
    deliveryMethods: function() {
      return `${this.payload.delivery_methods.toUpperCase()}`
    },
    visitingReason: function () {
      return ``
    },

    timeActive: function () {
      console.log("Gate Modal", "Time Active", this.payload.time_active)
      let value = this.formatDate(new Date(this.payload.time_active))
      return value
    },
    timeExpiration: function () {
      return this.formatDate(new Date(this.payload.expiration_time))
    },
    lastScanned: function () {
      if (this.payload.time_validated != null) {
        return this.formatDate(new Date(this.payload.time_validated))
      }
      return ``
    },
    rulesAccepted: function () {
      return this.payload.rules_accepted ? "Yes" : "No"
    },
    timesVisited: function () {
      return Math.floor(Math.random() * 100)
    },
    validateKeyEnabled: function () {
      const enabled = this.$featureEnabledForRole(Constants.CREATE_ENTRY_LOG_MODAL, this.$props.userData['custom:cts_role'])
      console.log("Is Validate Key Featured Enabled for Role", this.$props.userData['custom:cts_role'], enabled)
      return enabled
    }
  },
  methods: {
    show() {
      this.$modal.show();
    },
    close() {
      this.$emit('close')
    },
    beforeOpen(event) {
      console.log('Before Opening...', event)
    },
    addVisitorInfo() {
      this.$modal.show(Constants.CREATE_VISITOR_MODAL);
    },
    logIncident() {
      this.$modal.show(Constants.CREATE_INCIDENT_MODAL);
    },
    validateKey() {
      new CTSRepository(this.$props.organizationData).validateKey(this.payload.key_id, JSON.stringify({
        validator_uid: this.$props.userData.sub
      })).then(() => {
        this.close()
      })
    },
    resendKey() {

      this.$modal.show(ConfirmationModal, {
        keyData: this.payload,
        userData: this.$props.userData,
        organizationData: this.$props.organizationData,
        title: `Resend Key to ${this.visitorName}`,
        message: `Are you sure you want to Resend a key to ${this.visitorName}?`,
        disclaimer: `By clicking resend, you authorize an additional text message or email to be sent to ${this.visitorName} with a QR code.`,
        confirmText: "Resend",
        onConfirm: async () => {
          await new CTSRepository(this.$props.organizationData).resendKey(this.payload.key_id)
          await this.refreshData()
        }
      }, {
        width: 450,
        height: 'auto',
        adaptive: true,
        clickToClose: false
      })
    },
    updateKey() {
      this.$modal.show(EditKeyModal, {
        keyData: this.payload,
        userData: this.$props.userData,
        organizationData: this.$props.organizationData,
        title: `Update Key`,
        confirmText: "Update",
        cancelText: "Cancel",
        onConfirm: async (data) => {
          await new CTSRepository(this.$props.organizationData).updateKey(this.payload.key_id, JSON.stringify(data))
          await this.refreshData()
        }
      }, {
        width: 450,
        height: 'auto',
        adaptive: true,
        clickToClose: false
      })
    },
    cancelKey() {
      this.$modal.show(ConfirmationModal, {
        keyData: this.payload,
        userData: this.$props.userData,
        organizationData: this.$props.organizationData,
        title: `Cancel Key for ${this.visitorName}`,
        message: `Are you sure you want to cancel the key for ${this.visitorName}?`,
        disclaimer: `By clicking cancel, this visitor will no longer be able to access the community with this key.`,
        confirmText: "Yes",
        cancelText: "No",
        onConfirm: async () => {
          await new CTSRepository(this.$props.organizationData).updateKey(this.payload.key_id, JSON.stringify({
            current_status: "CANCELED"
          }))
          await this.refreshData()
        }
      }, {
        width: 450,
        height: 'auto',
        adaptive: true,
        clickToClose: false
      })
    },
    formatDate(date) {
      return `${date.toLocaleDateString()}\n${date.toLocaleTimeString()}`
    },
    getMappedName(id) {
      return this.$organizationMap[id] ?? id
    },
    async refreshData() {
      return await new CTSRepository(this.$props.organizationData).fetchKey(this.payload.key_id).then(data => {
        this.payload = {
          ...data
        }
      })
    }
  },
  mounted() {
    console.log("In modal")
    console.log("Gate Modal Params", this.$props)
  },
}
</script>

<style>
.modal-container {
  display: flex;
  flex-direction: column;
  background-color: #699991;
  color: white;
  border-radius: 20px;
}

.modal-header {
  padding: 1rem;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}

.button-container {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  margin-top: 1rem;
  margin-bottom: 1rem;
}


</style>